/** 客服数到套餐的映射 */
const accountNumToId: Record<number, Pay.PackageId> = {
  1: 1,
  2: 2,
  5: 3,
  6: 3,
  10: 4,
  15: 4,
};
export default accountNumToId;
